/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2021-03-01T14:27:19.658
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	getRentTagEditInit,
	getRentTagView
} from '@api/rentmanage/RentTag';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary)
	},
	actions: {
		getRentTagEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getRentTagEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getRentTagView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getRentTagView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
	}
};
